module.exports = __webpack_public_path__ + "img/TraumII.1c198f21.jpg";